import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WwniMappingService {

  constructor(private http: HttpClient) { }

  loadWwniData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Build payload with AngularJS structure
    let requestParams = { ...params };
    requestParams = Object.assign({}, globalService || {}, filterParams, requestParams);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  loadVarianceSubcategory(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Build payload with AngularJS structure
    let requestParams = { ...params };
    requestParams = Object.assign({}, globalService || {}, filterParams, requestParams);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  loadAuditData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Build payload with AngularJS structure
    let requestParams = { ...params };
    requestParams = Object.assign({}, globalService || {}, filterParams, requestParams);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveWwniMapping(
    baseUrl: string,
    saveData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=v3cjp3`;
    
    // Build payload EXACTLY like original AngularJS factory
    let params = Object.assign({}, globalService || {}, filterParams);
    
    // CRITICAL: Use jsonObj and jsonSettings like AngularJS factory
    // In AngularJS: saveProjectTagW(_data, _schdMs) where:
    // - jsonSettings = JSON.stringify(_data) - first parameter (saveData)
    // - jsonObj = JSON.stringify(_schdMs) - second parameter (also saveData in AngularJS call)
    params.jsonSettings = JSON.stringify(saveData);
    params.jsonObj = JSON.stringify(saveData);
    
    // Essential parameters with fallbacks
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    
    // Add process name (EXACTLY like AngularJS factory)
    params.process_name = "SAVE_WWNI_DETAILS";
    
    // Include checkLockedbj from rowData (NOT hardcoded)
    const checkLockedbj = [{
      "leid": saveData[0]?.source_combination_key ? rowData.SOURCE_LEID : undefined,
      "cdr_number": saveData[0]?.source_combination_key ? rowData.SOURCE_CDR_NO : undefined,
      "consol_group_key": saveData[0]?.source_combination_key ? rowData.CONSOL_GROUP_KEY : undefined,
      "reporting_period": saveData[0]?.source_combination_key ? rowData.REPORTING_PERIOD : undefined,
      "combination_key": saveData[0]?.source_combination_key ? rowData.SOURCE_COMBINATION_KEY : undefined,
      "scenario_key": parseInt(filterParams.scenario || params.scenario || "1")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
